import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentJointVerifyPhoneOtpSubmitOutput,
  type EnrollmentJointVerifyPhoneData,
  type EnrollmentJointVerifyPhoneLinkSubmitOutput,
} from '../../../../models'

export const getEnrollmentJointVerifyPhoneDataMock: EnrollmentJointVerifyPhoneData = {
  errors: [],
  isError: false,
  activePerson: {
    applicationId: '1234',
    path: '/enrollment/joint/verify-phone',
    progress: 20,
    phone: {
      countryPhoneCode: '1',
      phoneNumber: '5555555555',
    },
  },
}

export const submitEnrollmentJointVerifyPhoneLinkDataMock: EnrollmentJointVerifyPhoneLinkSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/verify-phone',
  },
}

export const submitEnrollmentJointVerifyPhoneOtpDataMock: EnrollmentJointVerifyPhoneOtpSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/home-address',
  },
}

export const mockGetEnrollmentJointVerifyPhoneData = graphql.mutation('getEnrollmentJointVerifyPhoneData', () => {
  return HttpResponse.json({
    data: {
      submitJointEnrollment: getEnrollmentJointVerifyPhoneDataMock,
    },
  })
})

export const mockSubmitEnrollmentJointVerifyPhoneLinkData = graphql.mutation(
  'submitEnrollmentJointVerifyPhoneLinkData',
  () => {
    return HttpResponse.json({
      data: {
        submitJointEnrollment: submitEnrollmentJointVerifyPhoneLinkDataMock,
      },
    })
  },
)

export const mockSubmitEnrollmentJointVerifyPhoneOtpData = graphql.mutation(
  'submitEnrollmentJointVerifyPhoneOtpData',
  () => {
    return HttpResponse.json({
      data: {
        submitJointEnrollment: submitEnrollmentJointVerifyPhoneOtpDataMock,
      },
    })
  },
)

export const mockEnrollmentJointVerifyPhone = [
  mockGetEnrollmentJointVerifyPhoneData,
  mockSubmitEnrollmentJointVerifyPhoneLinkData,
  mockSubmitEnrollmentJointVerifyPhoneOtpData,
]
